import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-workflow-mod-review',
  templateUrl: './workflow-mod-review.component.html',
  styleUrls: ['./workflow-mod-review.component.scss'],
})
export class WorkflowModReviewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WorkflowModReviewComponent>,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
